import axios from 'axios'

import { Bundle } from '../model/bundles.model'

export default class BundlesService {
  constructor(private host: string) {}

  fetchBundles(tariffId: string | number): Promise<Bundle[]> {
    return axios
      .get(`${this.host}/bonuses/v1/masmovil/bonuses`, { params: { tariffId } })
      .then((res) => res.data)
  }

  fetchPromos(tariffId: string | number, tariffPrice?: number): Promise<Bundle[]> {
    return axios
      .get(`${this.host}/promotions/v1/masmovil/promotions`, { params: { tariffId, tariffPrice } })
      .then((res) => res.data)
  }
}
